import React, { useState } from 'react';
import MaterialTable from 'material-table'
import {
  Edit, Delete, Check, Visibility,
} from '@material-ui/icons';
import { useStyles, tableIcons } from '../styles';

const TableInsights = (props) => {
  const {
    dataTable = [],
    onOpenView,
    hiddenDelete,
    hiddenEdit,
    hiddenAccept,
    onUpdateTest,
    onRejectTest,
    onAcceptTest,
    onSelectRow,
    columns,
    isResult,
    title,
    pageSize = 10,
    isSelection = false,
    loading,
  } = props;
  const classes = useStyles();
  const titleView = isResult ? 'Ver Resultado' : 'Ver Cambio';
  const [selected, setSelectedRow] = useState(null);
  let data = [];

  if (dataTable) {
    data = dataTable;
  }

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          title={title}
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: null,
            },
            body: {
              emptyDataSourceMessage: ' No hay datos en la tabla',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          //icons={tableIcons}
          isLoading={loading}
          columns={columns}
          data={data}
          onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow.tableData.id)}
          options={{
            pageSize,
            loadingType: 'linear',
            actionsColumnIndex: -1,
            draggable: false,
            filtering: false,
            search: true,
            padding: 'dense',
            exportAllData: true,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            addRowPosition: 'first',
            exportFileName: 'Exportación Lucia Analitics',
            headerStyle: {
              backgroundColor: '#1B1B1B',
              color: '#FFF',
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selected === rowData.tableData.id ? '#EEE' : '#FFF',
              fontSize: 14,
            }),
            selection: isSelection,
            selectionProps: (rowData) => ({
              color: rowData?.tableData?.estado == 1 ? 'primary' : 'secondary',
            }),
          }}
          onSelectionChange={(rowData, selectedRow) => onSelectRow(selectedRow)}
          actions={[
            {
              icon: () => <Visibility />,
              tooltip: 'Ver Cambio',
              onClick: (event, rowData) => onOpenView(rowData),
            },
            {
              icon: () => <Check />,
              tooltip: 'Aceptar',
              onClick: (event, rowData) => onAcceptTest(rowData),
              hidden: hiddenAccept,
            },
            {
              icon: () => <Delete />,
              tooltip: 'Rechazar',
              onClick: (event, rowData) => onRejectTest(rowData),
              hidden: hiddenDelete,
            },
            {
              icon: () => <Edit style={{ color: '#FFA500' }} />,
              tooltip: titleView,
              onClick: (event, rowData) => onUpdateTest(rowData),
              hidden: hiddenEdit,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default TableInsights;
